"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCSV = exports.downloadCSVFile = void 0;
function downloadCSVFile(csv, fileName) {
    var BOM = new Uint8Array([0xef, 0xbb, 0xbf]);
    var blob = new Blob([BOM, csv], { type: "text/csv; charset=utf-8" });
    var url = (window.URL || window.webkitURL).createObjectURL(blob);
    var downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = fileName;
    downloadLink.click();
}
exports.downloadCSVFile = downloadCSVFile;
// https://www.ietf.org/rfc/rfc4180.txt
//   CR = %x0D ;as per section 6.1 of RFC 2234 [2]
//   LF = %x0A ;as per section 6.1 of RFC 2234 [2]
//   CRLF = CR LF ;as per section 6.1 of RFC 2234 [2]
var CRLF = "\r\n";
function toCSV(matrix) {
    // 1.  Each record is located on a separate line, delimited by a line
    //     break (CRLF)
    //console.log("csv", matrix.map(toCSVLine).join(CRLF))
    return matrix.map(toCSVLine).join(CRLF);
}
exports.toCSV = toCSV;
// 2. - 5. optional stuff not useful to us for creating a CSV file from a matrix
function toCSVLine(array) {
    return array
        .map(function (a) {
        // 6.  Fields containing line breaks (CRLF), double quotes, and commas
        //     should be enclosed in double-quotes.
        return a.includes('"') || a.includes(CRLF) || a.includes(",")
            ? // 7.  If double-quotes are used to enclose fields, then a double-quote
                //        appearing inside a field must be escaped by preceding it with
                //        another double quote.
                "\"".concat(a.replace(/"/g, '""'), "\"")
            : a;
    })
        .join(",");
}
